import { PlusIcon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

import { AvatarList } from '@/components/lemmala-design-system/avatar'
import { Button } from '@/components/lemmala-design-system/button/button'
import { buttonVariants } from '@/components/lemmala-design-system/button/button-variants'

type RecipientsButtonProps = {
  recipientsEmails: string[]
  onClick: () => void
  readonly?: boolean
}

export const RecipientsButton = ({
  recipientsEmails,
  onClick,
  readonly = false,
}: RecipientsButtonProps) => {
  const content = (
    <div className='flex items-center gap-1'>
      {recipientsEmails.length === 0 && <PlusIcon className='size-4' />}
      <span>Recipients</span>
      <AvatarList labels={recipientsEmails} size='small' maxVisible={3} />
    </div>
  )

  if (readonly) {
    return (
      <div
        className={cn(
          buttonVariants({ variant: 'ghost', size: 'sm', className: 'hover:bg-transparent' }),
          'cursor-default',
        )}
      >
        {recipientsEmails.length === 0 ? 'No recipients' : content}
      </div>
    )
  }

  return (
    <Button variant='ghost' size='sm' onClick={onClick}>
      {content}
    </Button>
  )
}
